import {Dispatch, SetStateAction, useState} from "react";
import {resetUnreadMessages, updateChatroom} from "@web-libs/features/chat/domain/chat.functions";
import {ChatRepository} from "@web-libs/features/chat/domain/chat.repository";
import {Chatroom} from "@web-libs/features/chat/domain/types/chatroom.type";
import {Chat} from "@web-libs/features/chat/domain/types/chat.type";

export type SetChatFunction = Dispatch<SetStateAction<Chat>>;
export type OpenChatroomEmitter = (id:string) => void;
export const useCurrentChatroom = (setChat:SetChatFunction, chatRepo:ChatRepository, openChatroomEmitter: OpenChatroomEmitter) => {
    const [currentOpenChatroom, setCurrentOpenChatroom] = useState<string | undefined>(undefined);
    const [currentChatroomLoading, setCurrentChatroomLoading] = useState<boolean>(true);
    const [currentChatroomError, setCurrentChatroomError] = useState<boolean>(false);

    const openChatroom = async (chatroomId: string) => {
        setCurrentOpenChatroom(chatroomId);
        openChatroomEmitter(chatroomId);
        setChat((chat) => {
            return resetUnreadMessages(chat, chatroomId);
        })
        setCurrentChatroomLoading(true);
        setCurrentChatroomError(false);
        try{
            const chatroom = await chatRepo.getChatroom(chatroomId);
            chatroom.unreadMessages = 0;

            chatRepo.readChatroom(chatroomId);

            setChat((chat) => {
                return updateChatroom(chat, chatroom)
            });
        } catch (e) {
            setCurrentChatroomError(true);
        } finally {
            setCurrentChatroomLoading(false);
        }
    }

    const tryOpeningFirstChatroom = (chatrooms:Chatroom[]) => {
        if(currentOpenChatroom == undefined) {
            const firstChatroomId = chatrooms[0]?.id;
            if(firstChatroomId) openChatroom(firstChatroomId);
        }
    }

    return {
        currentOpenChatroom,
        openChatroom,
        tryOpeningFirstChatroom,
        currentChatroomLoading,
        setCurrentChatroomLoading,
        currentChatroomError
    }
}
